import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/lighthouse-check")({
  beforeLoad: () => {
    throw redirect({ to: "/tools/lighthouse-check", replace: true });
  },
});
